import { useState, useEffect } from 'react';
import { Switch } from '@material-ui/core';
import styles, { useToggleStyles } from './styles';

interface ToggleProps {
  label: string;
  id: string;
  onClick: (value: boolean) => void;
  isToggled?: boolean;
}

function Toggle({
  label,
  id,
  onClick,
  isToggled: initialIsToggled = false,
}: ToggleProps): JSX.Element {
  const classes = useToggleStyles();

  const [isToggled, setIsToggled] = useState(initialIsToggled);
  useEffect(() => {
    setIsToggled(initialIsToggled);
  }, [initialIsToggled]);

  function handleClick(): void {
    const newValue = !isToggled;
    setIsToggled(newValue);
    onClick(newValue);
  }

  return (
    <span className="toggle-container">
      <label className="toggle-label" htmlFor={id}>
        {label}
      </label>
      <Switch
        inputProps={{ role: 'switch', id }}
        disableRipple
        classes={classes}
        onClick={handleClick}
        checked={isToggled}
      />
      <style jsx>{styles}</style>
    </span>
  );
}
export default Toggle;
